import { render, staticRenderFns } from "./Yellow.vue?vue&type=template&id=b248e414&scoped=true&"
import script from "./Yellow.vue?vue&type=script&lang=js&"
export * from "./Yellow.vue?vue&type=script&lang=js&"
import style0 from "./Yellow.vue?vue&type=style&index=0&id=b248e414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b248e414",
  null
  
)

export default component.exports